<span
  class="simple-text"
  [ngClass]="getTextColor()"
  [title]="simpleTextNavItemConfig.title | translate"
  >{{ simpleTextNavItemConfig.text | translate }}
  <span [ngClass]="{ 'd-xl-none': simpleTextNavItemConfig.hideText2OnDesktop }">
    {{ simpleTextNavItemConfig.text2 | translate }}
  </span>
</span>
